(() => {
    class Api extends App.Entities.Request {
        constructor() {
            super();
            this._id            = null;
            this._endpoint      = null;
            this._parameters    = {};
            this._response      = null;
            this.key            = App.Variable('frontendPublicKey');
            this._processData   = true;
        }

        get id() {
            return this._id;
        }

        set id(id) {
            this._id = id;
            return this;
        }

        get endpoint() {
            return this._endpoint;
        }

        set endpoint(endpoint) {
            /* Replace the symbolic '.' in endpoint names with '/' for the url-path. */
            this._endpoint = endpoint.replace(/\./g, '/');
            return this;
        }

        get key() {
            return this._key;
        }

        set key(key) {
            this.setHeader('MM-Api-Key', key);
            this._key = key;
            return this;
        }

        set parameters(parameters) {
            this._parameters = parameters;
        }

        get parameters() {
            return this._parameters;
        }

        get url() {
            let parts = [''];
            if (App.Data.getConfiguration('translationLanguage')) parts.push(App.Data.getConfiguration('translationLanguage'));
            parts.push('api');
            parts.push(this.endpoint);
            if (this.id) parts.push(this.id)

            let path    = parts.join('/');
            let uri     = '?' + URI.buildQuery(this.parameters);

            return path + uri;
        }

        get response() {
            return this._response;
        }

        set response(response) {
            this._response = response;
            return this;
        }

        get processData() {
            return this._processData;
        }

        set processData(processData) {
            this._processData = processData;
            return this;
        }
    }
    App.Entities.Api = Api;
})();
